import { Component, Input, OnInit } from '@angular/core';
import { RecruitPageConfigModel } from 'services/models/recruitment/recruitment-page-config.model';

@Component({
  selector: 'app-configurable-description',
  templateUrl: './configurable-description.component.html',
  styleUrls: ['./configurable-description.component.scss']
})
export class ConfigurableDescriptionComponent implements OnInit {
  
  @Input() config: RecruitPageConfigModel | null = null;
  @Input() fallbackDescription: string = 'Faça parte da nossa equipe!';
  @Input() cssClass: string = 'hero-subtitle';
  @Input() showCompanyName: boolean = true;
  @Input() companyName: string = '';

  public displayDescription: string = '';

  ngOnInit(): void {
    this.updateDisplayDescription();
  }

  ngOnChanges(): void {
    this.updateDisplayDescription();
  }

  private updateDisplayDescription(): void {
    if (this.config?.description && this.config.description.trim()) {
      this.displayDescription = this.config.description;
    } else {
      this.displayDescription = this.fallbackDescription;
    }

    // Adiciona o nome da empresa se solicitado
    if (this.showCompanyName && this.companyName) {
      this.displayDescription = this.displayDescription.replace(
        'nossa equipe', 
        `equipe da ${this.companyName}`
      );
    }
  }
}
